import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { TranslateModule } from '@ngx-translate/core';

import { EzidebitRecurringCardPageRoutingModule } from './ezidebit-card-routing.module';
import { EzidebitRecurringCardPage } from './ezidebit-card.page';
import { MasterHeaderModule } from '../../../../master-header/master-header.module';
import { MasterFooterModule } from '../../../../master-footer/master-footer.module';
import { CustomInputModule } from '../../../../common-components/custom-input/custom-input.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    IonicModule,
    EzidebitRecurringCardPageRoutingModule,
    MasterHeaderModule,
    MasterFooterModule,
    CustomInputModule,
    TranslateModule,
  ],
  declarations: [EzidebitRecurringCardPage],
})
export class EzidebitRecurringCardPageModule {}
